import "core-js/modules/es.function.name.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { HSpacer, InfoItem, ProductItemSection, Text, When } from '@aftersale-next/ui';
import { Img } from '@chakra-ui/react';
import { x } from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../utils/format-money';
export function ProductItem(_ref) {
  var product = _ref.product;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (!product) return null;
  return /*#__PURE__*/_jsxs(ProductItemSection, {
    children: [/*#__PURE__*/_jsx(When, {
      value: product.originalImages,
      children: /*#__PURE__*/_jsx(x.section, {
        display: "flex",
        h: "82px",
        children: /*#__PURE__*/_jsx(Img, {
          objectFit: "cover",
          boxSize: "82px",
          mr: 4,
          loading: "lazy",
          alt: "".concat(product.name, " image"),
          src: product.originalImages,
          onError: function onError(e) {
            e.currentTarget.style.display = 'none';
            e.currentTarget.alt = '';
          }
        })
      })
    }), /*#__PURE__*/_jsxs(x.section, {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column",
      gap: "8px",
      children: [/*#__PURE__*/_jsx(Text, {
        size: "15px",
        weight: "700",
        children: product.name
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "4px"
      }), /*#__PURE__*/_jsx(InfoItem, {
        horizontal: true,
        label: "".concat(t('REFERENCE'), ":"),
        value: product.sku
      }), /*#__PURE__*/_jsx(InfoItem, {
        horizontal: true,
        label: "".concat(t('QUANTITY'), ":"),
        value: product.qty < 10 ? "0".concat(product.qty) : product.qty
      }), /*#__PURE__*/_jsx(InfoItem, {
        horizontal: true,
        label: "".concat(t('PRICE'), ":"),
        value: formatMoney(product.sellingPrice)
      })]
    })]
  });
}